import React from "react";
import { motion } from "framer-motion";
import { FaQuoteLeft } from "react-icons/fa";
import Slider from "react-slick";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Sarah B.",
    feedback:
      "Mosaic Tech transformed my startup idea into a stunning product. The team is insanely talented and professional.",
  },
  {
    name: "Tunde K.",
    feedback:
      "From design to deployment, the Mosaic team handled everything with care and precision. Highly recommended!",
  },
  {
    name: "Linda O.",
    feedback:
      "They listened, collaborated, and over-delivered. Our digital presence has never been stronger.",
  },
  {
    name: "James A.",
    feedback:
      "We saw results quickly — traffic, leads, and client trust improved across the board.",
  },
];

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    pauseOnHover: true,
  };

  return (
    <section className="testimonials-section dark-bg">
      <motion.h2
        className="testimonial-heading"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        What People Are Saying About Mosaic Tech
      </motion.h2>

      <Slider {...settings}>
        {testimonials.map((item, idx) => (
          <div key={idx} className="testimonial-card">
            <motion.div
              className="quote-box"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              <FaQuoteLeft className="quote-icon" />
              <p className="quote-text">"{item.feedback}"</p>
              <h4 className="quote-author">— {item.name}</h4>
            </motion.div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Testimonials;
